import { Moon, Sun } from 'lucide-react';
import { useI18n } from '@/shared/contexts/I18nProvider';
import { useTheme } from '@/shared/contexts/ThemeProvider';
import { Button } from '@/shared/components/ui';
import { motion } from 'framer-motion';

const ThemeToggle = () => {
  const { content } = useI18n();
  const { theme, setTheme } = useTheme();

  const nextTheme = theme === 'light' ? 'dark' : 'light';
  const label =
    nextTheme === 'light'
      ? content.theme.switchToLightMode
      : content.theme.switchToDarkMode;

  return (
    <Button
      variant="ghost"
      onClick={() => setTheme(nextTheme)}
      className="relative h-9 w-9 cursor-pointer rounded-md border border-border-primary/70 bg-background-card/35 p-0 text-text-primary shadow-sm shadow-shadow backdrop-blur-md hover:bg-background-hover/70"
      aria-label={label}
      title={label}
    >
      <motion.div
        key={theme}
        initial={{ rotate: -180, opacity: 0 }}
        animate={{ rotate: 0, opacity: 1 }}
        exit={{ rotate: 180, opacity: 0 }}
        transition={{ duration: 0.2 }}
      >
        {theme === 'light' ? (
          <Sun className="h-4 w-4" />
        ) : (
          <Moon className="h-4 w-4" />
        )}
      </motion.div>
    </Button>
  );
};

export default ThemeToggle;
